<template>
  <div class="row-box">
    <WrapperField
      v-for="(value, key, index) in data"
      :key="value + key + index"
      :data="
        createDataField({
          fieldName: key,
          fieldValue: value,
          fieldGroup: FieldGroup.DOCUMENT_CONVERSION_DETAILS,
        })
      "
    />
  </div>
</template>

<script>
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import { createDataField, FieldGroup } from '@/utils/fullStatementView';

export default {
  name: 'Step3',
  props: ['data'],
  components: {
    WrapperField,
  },
  data: () => ({
    FieldGroup,
    createDataField,
  }),
};
</script>
